import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { Component, OnInit } from '@angular/core';
import TileLayer from 'ol/layer/Tile';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'ebw-world-layer-change',
  templateUrl: './world-layer-change.component.html',
  styleUrls: ['./world-layer-change.component.scss']
})
export class WorldLayerChangeComponent implements OnInit {
  public LAYER_KEY = MapService.LABEL_LAYER_KEY;
  constructor(public mapService: MapService) {}

  /**
   * Variable that stores in the component the names of the world layers so they can be used on the template.
   */
  worldLayersList: { id: string; label: string }[] = [];
  layerOpacity = 1;
  layerSaturation = 0;
  overlayIsOpen = false;
  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 0,
      offsetY: -50,
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'bottom'
    }
  ];

  googleMapDiv: HTMLElement;
  isGoogleLayerActive = false;

  ngOnInit(): void {
    //Get the name of world layers from the MapService and put them on the component layer list
    this.worldLayersList = this.mapService.getWorldLayers().sort((a, b) => a.order - b.order);
  }

  /**
   * Handle the change of the world layer.
   * It uses the MapService method changeWorldLayer.
   * @param worldLayerTitle Name of the world layer to change.
   */
  changeWorldLayer(worldLayerId: string): void {
    this.mapService.changeWorldLayer(worldLayerId);
  }

  onOpacityLayerChange(event: number) {
    this.layerOpacity = event;
    this.mapService.activeBaseLayer.setOpacity(this.layerOpacity);
    this.mapService.googleMapsMap.googleMap.getDiv().style.opacity = this.layerOpacity.toString();
  }

  onSaturationLayerChange(event: number) {
    this.layerSaturation = event;
    this.mapService.googleMapsMap.googleMap.getDiv().style.filter = `grayscale(${Math.abs(this.layerSaturation)}%)`;
  }

  onOverlayRequest() {
    this.isGoogleLayerActive = (this.mapService.activeBaseLayer as TileLayer<any>).getProperties().googleMapsTypology;
    this.overlayIsOpen = !this.overlayIsOpen;
  }
}
